import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import type { PerspectiveCamera, CatmullRomCurve3 } from "three";

gsap.registerPlugin(ScrollTrigger);

export interface TimelineHandle {
  progress: () => number;
  destroy: () => void;
}

export function createTimeline(opts: {
  camera: PerspectiveCamera;
  path: CatmullRomCurve3;
  onProgress: (p: number) => void;
}): TimelineHandle {
  const state = { p: 0 };
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: "#scroll-spine",
      start: "top top",
      end: "bottom bottom",
      scrub: 1,
      onUpdate: (self) => {
        state.p = self.progress;
        const pos = opts.path.getPoint(self.progress);
        opts.camera.position.copy(pos);
        opts.camera.lookAt(0, 0, 0);
        opts.onProgress(self.progress);
      },
    },
  });
  return { progress: () => state.p, destroy: () => tl.kill() };
}
